import { Footer as HeaderFooter } from '@splunk-iteng/header-footer'

function Footer() {
  return <HeaderFooter testId="footer-testid" variant="light" />
}

export default Footer
